import { render, staticRenderFns } from "./compareModal.vue?vue&type=template&id=6c99d5b5&scoped=true&"
import script from "./compareModal.vue?vue&type=script&lang=js&"
export * from "./compareModal.vue?vue&type=script&lang=js&"
import style0 from "./compareModal.vue?vue&type=style&index=0&id=6c99d5b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99d5b5",
  null
  
)

export default component.exports